import { Seo } from "@/components/Seo";
import { useT } from "@/lib/i18n";
import { useLeadTimes } from "@/lib/settings";
import { HeroSection } from "./HeroSection";
import { FeaturedHighlights } from "./FeaturedHighlights";
import { UspRow } from "./UspRow";
import { GlassCategories } from "./GlassCategories";
import { ConfiguratorExplainer, ConfiguratorFaq, configuratorHowToJsonLd, configuratorFaqJsonLd } from "./ConfiguratorExplainer";
import { BeslagTeaser } from "./BeslagTeaser";
import { FeaturedDeals } from "./FeaturedDeals";
import { KennisbankRow } from "./KennisbankRow";
import { RecentlyViewed } from "./RecentlyViewed";

export function HomePage() {
  const t = useT();
  // Dezelfde admin-levertijden als in de zichtbare FAQ eronder — anders vertelt de
  // structuurdata Google iets anders dan wat de bezoeker leest.
  const leadTimes = useLeadTimes();
  return (
    <>
      <Seo
        title={t("Glas op maat samenstellen & bestellen")}
        description={t("Glas op maat en glasartikelen online bestellen — een glasplaat op de millimeter gezaagd, met boringen, uitsparingen en geslepen randen. Verzekerd geleverd.")}
        canonicalPath="/"
        jsonLd={[configuratorHowToJsonLd, configuratorFaqJsonLd(leadTimes)]}
      />
      <h1 className="sr-only">{t("Glas op maat en glasartikelen bestellen bij Glastotaal")}</h1>

      {/* 1. Hero — glas op maat als kernboodschap (50/50 split) */}
      <HeroSection />

      {/* 1b. Uitgelicht — 3 vaste highlight-boxen direct onder de hero */}
      <FeaturedHighlights />

      {/* 2. Ontdek — 6 glassoorten met vanaf-prijs (compleet, geen doorklik nodig). */}
      <section className="mx-auto max-w-[1600px] px-4 pt-10 sm:pt-14">
        <h2 className="text-lg font-bold text-primary-900 sm:text-2xl">{t("Bekijk onze glassoorten")}</h2>
        <GlassCategories />
      </section>

      {/* 4. Vertrouwen: 4 USP's als trustbar */}
      <UspRow />

      {/* 5. Hoe werkt de configurator */}
      <ConfiguratorExplainer />

      {/* 6. Cross-sell: beslag, kit & gereedschap (artikelen-kant) */}
      <BeslagTeaser />

      {/* 7. Nu in de aanbieding (navy blok) — vult zichzelf automatisch met afgeprijsde producten */}
      <FeaturedDeals />

      {/* 8. Kennisbank-rij — blog/uitlegartikelen */}
      <KennisbankRow />

      {/* 10. Veelgestelde vragen — zichtbare Q&A die de FAQPage-JSON-LD matcht (SEO + GEO) */}
      <ConfiguratorFaq />

      {/* Recent bekeken — onderaan, vlak boven de USP-band/footer (leeg = verborgen) */}
      <div className="pb-14">
        <RecentlyViewed />
      </div>
    </>
  );
}
